import { Select } from "@mantine/core";
import React, { useState } from "react";
import Chart from "react-apexcharts";

const TrandingDataChart = ({isDark}) => {
  const [selectedToken, setSelectedToken] = useState("BNB");

  const handleChange = (e) => {
    setSelectedToken(e.target.value);
  };

  const series = [22.35, 12.46, 5.43, 32.72, 20.74, 6.31]; // percentages
  const options = {
    chart: {
      type: "donut",
    },
    labels: ["A", "B", "C", "D", "E", "F"], // Replace with actual category names if needed
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return `${val.toFixed(2)} %`;
      },
    },
    legend: {
      show: false,
    },
    colors: ["#e74c3c", "#f1948a", "#fadbd8", "#27ae60", "#2ecc71", "#82e0aa"],
    stroke: {
      width: 1,
    },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
        },
      },
    },
  };

  // tradingoption

  const tradingSeries = [
    {
      name: "BNB",
      data: [
        [new Date("2025-08-03T12:00:00").getTime(), 0.02],
        [new Date("2025-08-03T15:00:00").getTime(), 0.01],
        [new Date("2025-08-03T18:00:00").getTime(), 0.015],
        [new Date("2025-08-03T21:00:00").getTime(), -0.7],
        [new Date("2025-08-04T00:00:00").getTime(), 0.01],
        [new Date("2025-08-04T03:00:00").getTime(), -0.3],
        [new Date("2025-08-04T06:00:00").getTime(), -0.1],
        [new Date("2025-08-04T09:00:00").getTime(), -0.2],
      ],
    },
  ];

  const tradingOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: ["#fbc531"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.3,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        datetimeFormatter: {
          hour: "HH:mm",
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: -0.75,
      max: 0.25,
      tickAmount: 4,
      labels: {
        formatter: (val) => `${val.toFixed(2)}%`,
      },
    },
    tooltip: {
      x: {
        format: "dd MMM HH:mm",
      },
    },
    grid: {
      strokeDashArray: 4,
    },
  };

  // chartOptions

  const inflowValues = [19790, -5290, -24230, -20520, -13850];
  const inflowLabels = ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5"];

  const chartOptions = {
    chart: {
      type: "bar",
      toolbar: { show: true },
    },
    plotOptions: {
      bar: {
        columnWidth: "65%",
        distributed: false,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => {
        const isNegative = val < 0;
        const display = Math.abs(val).toLocaleString();
        return `${isNegative ? "-" : ""}${display.slice(0, -3)}.${display.slice(
          -3,
          -1
        )}K`;
      },
      offsetY: -10,
      style: {
        fontSize: "12px",
      },
    },
    colors: inflowValues.map((val) => (val >= 0 ? "#2ecc71" : "#e74c3c")),
    xaxis: {
      categories: inflowLabels,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: { show: false },
    },
    yaxis: {
      show: false,
    },
    grid: {
      yaxis: { lines: { show: true } },
      xaxis: { lines: { show: false } },
    },
    tooltip: {
      enabled: false,
    },
    grid: {
  
 
  borderColor: '#e0e0e0', 
  strokeDashArray: 2,     
},
  };

  const chartData = [
    {
      name: "Large Inflow",
      data: inflowValues,
    },
  ];

  // const totalInflow = inflowValues.reduce((a, b) => a + b, 0);
  // const formattedTotal =
  //   (totalInflow < 0 ? "-" : "") +
  //   Math.abs(totalInflow).toLocaleString().slice(0, -3) +
  //   "K";

  // Margin Long-short Positions Ratio\

  const ratioData = [
    [new Date("2025-08-03T12:00:00").getTime(), 13.8],
    [new Date("2025-08-03T15:00:00").getTime(), 13.7],
    [new Date("2025-08-03T18:00:00").getTime(), 13.6],
    [new Date("2025-08-03T21:00:00").getTime(), 13.65],
    [new Date("2025-08-04T00:00:00").getTime(), 13.7],
    [new Date("2025-08-04T03:00:00").getTime(), 13.75],
    [new Date("2025-08-04T06:00:00").getTime(), 13.8],
    [new Date("2025-08-04T09:00:00").getTime(), 13.85],
  ];

  const chartOptions2 = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: ["#f1c40f"],
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 100],
        colorStops: [],
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        format: "HH:mm",
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 15,
      tickAmount: 3,
      labels: {
        formatter: (val) => val.toFixed(2),
      },
    },
    grid: {
      show: true,
      borderColor: "#e0e0e0",
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    tooltip: {
      x: { format: "dd MMM HH:mm" },
    },
  };

  const chartData2 = [
    {
      name: "Long/Short Ratio",
      data: ratioData,
    },
  ];

  // 5th chart

  const chartData5 = [
    [new Date('2025-08-03T12:00:00').getTime(), 0],
    [new Date('2025-08-03T14:00:00').getTime(), 800],
    [new Date('2025-08-03T16:00:00').getTime(), -1000],
    [new Date('2025-08-03T18:00:00').getTime(), -2000],
    [new Date('2025-08-03T20:00:00').getTime(), -3000],
    [new Date('2025-08-04T00:00:00').getTime(), -4200],
    [new Date('2025-08-04T03:00:00').getTime(), -6000],
    [new Date('2025-08-04T06:00:00').getTime(), -8500],
    [new Date('2025-08-04T09:00:00').getTime(), -7800],
  ];

  const fivechart = {
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
      colors: ['#f1c40f'],
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        format: 'HH:mm',
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: -10000,
      max: 5000,
      tickAmount: 5,
      labels: {
        formatter: (val) => val.toLocaleString(undefined, { minimumFractionDigits: 2 }),
      },
    },
    grid: {
      borderColor: '#eee',
      strokeDashArray: 4,
      xaxis: {
        lines: { show: false },
      },
      yaxis: {
        lines: { show: true },
      },
    },
    tooltip: {
      x: { format: 'dd MMM HH:mm' },
      y: {
        formatter: (val) => `${val >= 0 ? '+' : ''}${val.toLocaleString()}`
      },
      theme: isDark ? 'dark' : 'light', 
    },
  };

  const fivechartss = [
    {
      name: 'Inflow',
      data: chartData5,
    },
  ];
   
  // 6th chaRT

  const borrowRatioData = [
    [new Date('2025-08-03T12:00:00').getTime(), 1.2],
    [new Date('2025-08-03T15:00:00').getTime(), 2.1],
    [new Date('2025-08-03T17:00:00').getTime(), 130.5],  // spike
    [new Date('2025-08-03T19:00:00').getTime(), 0.5],
    [new Date('2025-08-03T22:00:00').getTime(), 0.8],
    [new Date('2025-08-04T01:00:00').getTime(), 0.7],
    [new Date('2025-08-04T04:00:00').getTime(), 15.6],
    [new Date('2025-08-04T06:00:00').getTime(), 0.2],
    [new Date('2025-08-04T09:00:00').getTime(), 0.1],
  ];

  const optionssix = {
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: 'straight',
      width: 2,
      colors: ['#f1c40f'],
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.4,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        format: 'HH:mm',
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      min: 0,
      max: 150,
      tickAmount: 4,
      labels: {
        formatter: (val) => val.toFixed(2),
      },
    },
    grid: {
      strokeDashArray: 4,
      borderColor: '#e0e0e0',
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    tooltip: {
      x: { format: 'dd MMM HH:mm' },
    },
  };

  const seriessix = [
    {
      name: 'Borrow Ratio',
      data: borrowRatioData,
    },
  ];

  return (
    <div className="flex justify-between h-96 overflow-scroll">
      {/* 1st chart */}
      <div className="w-full max-w-sm mx-auto">
        <h2>Money Flow Analysis</h2>
        <Chart
          options={options}
          series={series}
          type="donut"
          width="60%"
          className="justify-between flex"
        />
        {/* 3rd chart */}
        <div className="p-4 rounded shadow w-full max-w-sm mx-auto">
          <h2 className="text-sm font-semibold mb-1">
            24hr Large Inflow (<span className="">BNB</span>)
          </h2>
          <p className="text-xs text-gray-500 mb-2">
            5 days large inflow: <span className="text-red-500">-44.09K</span>
          </p>
          <Chart
            options={chartOptions}
            series={chartData}
            type="bar"
            height={200}
          />
        </div>
        {/* 5th chart */}
        <div className="p-4 rounded shadow w-full max-w-md mx-auto">
      <h2 className="text-sm font-semibold mb-2">
        24hr Large Inflow BNB
      </h2>
      <Chart options={fivechart} series={fivechartss} type="area" height={250} />
    </div>
      </div>

      {/* 2nd chart */}
      <div>
        <div className="p-4 rounded shadow w-full max-w-md mx-auto">
          <h2 className="text-sm font-medium mb-2 flex items-center">
            Margin Debt Growth
          </h2>
          <div className="flex justify-between items-center text-xs font-semibold">
            <div className="flex space-x-2">
              <button className="px-2 py-1 rounded">24h</button>
              <button className="px-2 py-1 rounded">30d</button>
            </div>
            <div className="text-sm px-2 py-0.5 rounded">
              <select
                value={selectedToken}
                onChange={handleChange}
                className="w-full px-2 py-1 border rounded text-sm bg-transparent"
              >
                <option className="text-gray-700">BNB</option>
                <option>USDT</option>
              </select>
            </div>
          </div>

          <Chart
            options={tradingOptions}
            series={tradingSeries}
            type="area"
            height={250}
          />
        </div>
        {/* 4th chart */}
        <div className="p-4 rounded shadow w-full max-w-md mx-auto mt-2">
          <h2 className="text-sm font-semibold mb-1">
            Margin Long-short Positions Ratio{" "}
           
          </h2>

          <div className="flex justify-between items-center text-xs font-semibold">
            <div className="flex space-x-2">
              <button className="px-2 py-1 rounded">
                24h
              </button>
              <button className="text-gray-500 px-2 py-1 rounded">30d</button>
            </div>
            <div className="text-sm px-2 py-0.5">
               <select
                value={selectedToken}
                onChange={handleChange}
                className="w-full px-2 py-1 border rounded text-sm bg-transparent"
              >
                <option className="text-gray-700">BNB</option>
                <option>USDT</option>
              </select>
            </div>
          </div>

          <Chart
            options={chartOptions2}
            series={chartData2}
            type="area"
            height={250}
          />
        </div>
        <div className="p-4 rounded shadow w-full max-w-md mx-auto">
      <h2 className="text-sm font-semibold mb-1">
        Isolated Margin Borrow Amount Ratio 
      </h2>

      {/* Tabs */}
      <div className="flex justify-start space-x-2 text-xs font-medium mb-2">
        <button className="bg-black text-white px-2 py-1 rounded">24h</button>
        <button className="px-2 py-1 rounded">30d</button>
      </div>

      <Chart options={optionssix} series={seriessix} type="area" height={250} />
    </div>
      </div>
      <div></div>
    </div>
  );
};

export default TrandingDataChart;
